import script from "./MandatoryLastLessonsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MandatoryLastLessonsCard.vue?vue&type=script&setup=true&lang=js"

import "./MandatoryLastLessonsCard.vue?vue&type=style&index=0&id=7dcded8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcded8c"]])

export default __exports__